import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRatingPoor(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 4h3v10H3V4Zm18 9.35c0 .935-.731 1.7-1.625 1.7h-5.127l.772 3.884.024.272c0 .349-.138.672-.357.902l-.861.892-5.347-5.601A1.7 1.7 0 0 1 8 14.2V5.7C8 4.765 8.731 4 9.625 4h7.313c.674 0 1.25.425 1.495 1.037l2.453 5.993c.073.195.114.399.114.62v1.623l-.008.009.008.068Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
